import styled, { css } from 'styled-components';

const PlusTagContainer = styled.div`
  display: inline-flex;
  align-items: center;

  svg {
    & > path {
      fill: ${({ theme }) => theme.colors.white};
      &:first-child {
        fill: ${({ theme }) => theme.colors.red};
      }
    }
  }
  
  & > div {
    margin-right: ${({ theme }) => theme.spacing(2)};
    color: ${({ theme }) => theme.commons.tags.plus.color};
    background: ${({ theme }) => theme.commons.tags.plus.background};
    ${({ desktopMode, isPickup, theme }) =>
      desktopMode && isPickup
        ? css`
            padding: ${theme.spacing(2, 0, 2, 2)};
          `
        : css`
            padding-right: ${theme.spacing(0)};
            padding-top: ${theme.spacing(1)};
            padding-bottom: ${theme.spacing(1)};
          `}
`;

export default PlusTagContainer;
